<template>
    <div >
        <div id="home" class="md-layout">
            <div class="md-layout-item md-size-100" style="text-align:center">
                <p><strong>Bienvenido a nuestra plataforma.</strong></p>
            </div>
            <router-link to="/regiones" class="md-layout-item md-size-25 md-xsmall-size-50">
                <md-card class="md-card-stats" >
                    <md-card-content>
                        <md-icon>language</md-icon>
                        <h3>Regiones</h3>
                        <p>Resumen regional de los principales indicadores del negocio agrícola.</p>
                    </md-card-content>
                </md-card>
            </router-link>
            <router-link to="/comparativa" class="md-layout-item md-size-25 md-xsmall-size-50">
                <md-card class="md-card-stats">
                    <md-card-content>
                        <md-icon>timeline</md-icon>
                        <h3>Comparativa</h3>
                        <p>Seleccione y compare entre cultivos y regiones.</p>
                    </md-card-content>
                </md-card>
            </router-link>
            <router-link to="/cultivos" class="md-layout-item md-size-25 md-xsmall-size-50">
                <md-card class="md-card-stats mt20">
                    <md-card-content>
                        <md-icon>spa</md-icon>
                        <h3>Cultivos</h3>
                        <p>Indicadores específicos por región y cultivo.</p>
                    </md-card-content>
                </md-card>
            </router-link>
            <router-link to="/precios" class="md-layout-item md-size-25 md-xsmall-size-50">
                <md-card class="md-card-stats mt20">
                    <md-card-content>
                        <md-icon>attach_money</md-icon>
                        <h3>Precios</h3>
                        <p>Evolución de las variables fundamentales del negocio.</p>
                    </md-card-content>
                </md-card>
            </router-link>
            <div class="md-layout-item md-size-25 advertiser-container md-xsmall-size-50">
                <a href="https://www.eseade.edu.ar/" target="_blank"><img :src="'img/pub/eseade.png' + randomVersion"></a>
            </div>
            <div class="md-layout-item md-size-25 advertiser-container md-xsmall-size-50">
              <a href="https://www.az-group.com.ar/" target="_blank"><img :src="'img/pub/agbi.png' + randomVersion"></a>
            </div>
            <div class="md-layout-item md-size-25 advertiser-container md-xsmall-size-50">
              <a href="http://www.simplezasa.com/" target="_blank"><img :src="'img/pub/simpleza.png' + randomVersion"></a>
            </div>
            <div class="md-layout-item md-size-25 advertiser-container md-xsmall-size-50">
              <a href="https://www.fca-ude.edu.uy/" target="_blank"><img :src="'img/pub/facultad.png' + randomVersion"></a>
            </div>

        </div>
        <div class="md-layout">
            <div class="md-layout-item md-size-100 about">
                <h4>Acerca de AgBI</h4>
                <p><strong>AgBI</strong> es una plataforma colaborativa de Inteligencia en Negocios aplicada al sector agroindustrial. En base al conocimiento técnico del equipo y la información del mercado, <strong>AgBI</strong> permite comprender en forma clara y simple la estructura económica de los negocios del sector y analizar las principales variables de incidencia. <strong>AgBI</strong> se presenta como una herramienta de soporte a la toma de decisiones, y su estructura de tablero de control permite comparar entre negocios y regiones.</p>
                <h4>Cómo funciona?</h4>
                <p>Conforme a planteos productivos consensuados con técnicos zonales y normas de gestión de referencia, <strong>AgBI</strong> estructura costos productivos y resultados económicos en forma clara. Presenta las principales variables que afectan los márgenes de cada actividad y zona, para que puedan ser analizadas de manera simple.</p>
            </div>
        </div>
        <div class="md-layout">
            <!--<div class="md-layout-item md-size-100">
                <h4>Quienes Somos</h4><br><br>
            </div>
            <div class="md-layout-item md-size-25">
                <md-card class="md-card-profile az-staff">
                    <div class="md-card-avatar">
                    <img class="img" src="img/staff/agaldeano.jpg">
                    </div>

                    <md-card-content>
                    <h4 class="card-title">Alberto Galdeano</h4>

                    <p class="card-description" >
                        Especialista en Análisis de Riesgo en Agronegocios.<br><br>
                    </p>
                    <a class="md-button md-round md-info md-theme-default" href='https://www.linkedin.com/in/alberto-galdeano-b7372041' target='_BLANK'>Ver LinkedIn</a>
                    </md-card-content>
                </md-card>
            </div>
            <div class="md-layout-item md-size-25">
                <md-card class="md-card-profile az-staff">
                        <div class="md-card-avatar">
                            <img class="img" src="img/staff/dcurat.jpg">
                        </div>
                        <md-card-content>
                        <h4 class="card-title">Diego Curat</h4>
                        <p class="card-description" >
                            Apasionado en el desarrollo de equipos de trabajo con amplia experiencia en Agronegocios de Latinoamérica.
                        </p>
                        <a class="md-button md-round md-info md-theme-default" href='https://www.linkedin.com/in/diegocurat/' target='_BLANK'>Ver LinkedIn</a>
                        </md-card-content>
                </md-card>
            </div>
            <div class="md-layout-item md-size-25">
                <md-card class="md-card-profile az-staff">
                        <div class="md-card-avatar">
                        <img class="img" src="img/staff/jbattistoni.jpeg">
                        </div>

                        <md-card-content>
                        <h4 class="card-title">Jeremias Battistoni</h4>

                        <p class="card-description" >
                            Analista de investigación de mercados en AZGroup<br><br>
                        </p>

                        <a class="md-button md-round md-info md-theme-default" href='https://www.linkedin.com/in/jeremiasbattistoni/' target='_BLANK'>Ver LinkedIn</a>
                        </md-card-content>
                </md-card>
            </div>
            <div class="md-layout-item md-size-25">
                <md-card class="md-card-profile az-staff">
                        <div class="md-card-avatar">
                            <img class="img" src="img/staff/stiscornia.jpg">
                        </div>
                        <md-card-content>
                            <h4 class="card-title">Santiago Tiscornia</h4>
                            <p class="card-description" >
                                Analista de investigación de mercados en AZGroup<br><br><br><br>
                            </p>
                        </md-card-content>
                </md-card>
            </div>-->
            <div class="md-layout-item md-size-100">
                <div class="md-layout">
                    <div class="md-layout-item md-size-10 md-small-size-100">
                        <h3>Partners</h3>
                    </div>
                    <div class="md-layout-item md-size-15 md-small-size-30 md-xsmall-size-50">
                        <img :src="'img/pub/az_partners.png' + randomVersion" style="margin-top: 20px;">
                    </div>
                    <div class="md-layout-item md-size-15 md-small-size-30 md-xsmall-size-50">
                        <img :src="'img/simpleza.png' + randomVersion">
                    </div>
                </div>
            </div>
            <div class="md-layout-item md-size-50  md-xsmall-size-100">
                <div v-if='messageSent' class="alert alert-success">El mensaje ha sido enviado correctamente. Gracias por su consulta, en breve le responderemos.</div>
                <div v-if='messageFail' class="alert alert-error">Falló el envio del mensaje, intente nuevamente.</div>
                <form>
                    <md-card>
                    <md-card-header class="md-card-header-icon md-card-header-blue">
                        <div class="card-icon">
                        <md-icon>mail_outline</md-icon>
                        </div>
                        <h4 class="title">Contactenos</h4>
                    </md-card-header>

                    <md-card-content>
                        <md-field :class="[
                        {'md-valid': !errors.has('name') && touched.name},
                        {'md-error': errors.has('name')}]">
                            <label>Nombre y Apellido</label>
                            <md-input
                                v-model="name"
                                data-vv-name="name"
                                type="text"
                                required
                                v-validate="modelValidations.name">
                            </md-input>
                        </md-field>
                        <md-field :class="[
                        {'md-valid': !errors.has('email') && touched.email},
                        {'md-error': errors.has('email')}]">
                            <label>Email</label>
                            <md-input
                                v-model="email"
                                data-vv-name="email"
                                type="email"
                                required
                                v-validate="modelValidations.email">
                            </md-input>
                        </md-field>
                        <md-field :class="[
                        {'md-valid': !errors.has('message') && touched.message},
                        {'md-error': errors.has('message')}]">
                            <label>Mensaje</label>
                            <md-textarea
                                v-model="message"
                                data-vv-name="message"
                                required
                                v-validate="modelValidations.message">
                            </md-textarea>
                        </md-field>
                        <div class="form-category">* Campos requeridos</div>
                    </md-card-content>

                    <md-card-actions md-alignment="space-between">
                        <md-button native-type="submit" @click.native.prevent="validate" class="md-success">Enviar</md-button>
                    </md-card-actions>
                    </md-card>
                </form>
            </div>
            <div class="md-layout-item md-size-50 md-xsmall-size-100 advertiser-side">
                <a href="http://www.terramarjv.com.ar/" target="_blank"><img :src="'img/pub/terramar2.png' + randomVersion"></a>
            </div>
        </div>
        <video-modal @close="closeVideoModal" v-if="videoModal">
          <template slot="body">
            <iframe class="md-image" width="800" height="400" src="https://www.youtube.com/embed/2aMd7QCiDVM" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
          </template>
          <template slot="footer">
            <md-button class="md-danger md-simple" @click="closeVideoModal">Cerrar</md-button>
          </template>
        </video-modal>
    </div>
</template>

<script>
import axios from "axios";
import { mapState } from 'vuex'
import VideoModal from '@/components/VideoModal'
export default {

  data() {
    return {
      name: '',
      email: '',
      message: '',
      messageSent: false,
      messageFail : false,
      videoModal: false,
      modelValidations: {
        name: {
          required: true
        },
        email: {
          required: true,
          email: true
        },
        message: {
          required: true
        }
      },
      touched: {
        name: false,
        email: false,
        message: false
      }
    }
  },
  components: {VideoModal},
  computed: {
    ...mapState(['adv']),
    randomVersion() {
      return '?t='+Math.random();
    }
  },
  methods: {
    closeVideoModal() {
      this.videoModal= false;
    },
    advertiserLogo(index) {
      return this.adv.logo[index]+'?v='+Math.random();
    },
    validate() {
      this.messageFail = false;
      this.messageSent = false;
      this.$validator.validateAll().then(isValid => {
        if (isValid)

          axios.get('https://www.agbi.com.ar/mail.php', { params: {
            name: this.name,
            message: this.message,
            email: this.email
          }
          })
            .then(response => {
              if (response){
                this.messageSent = true;
              }
              else
                this.messageFail = true
            })
            .catch(error => {
              console.log(error)
            });

      })
    }
  },
  watch: {
    name(){
      this.touched.name = true
    },
    email(){
      this.touched.email = true
    },
    message(){
      this.touched.message = true
    }
  },
  mounted() {
    setTimeout(() => { this.videoModal = true; }, 3000);
  }

}
</script>
<style>
a.md-button{
    padding:15px
}
#home .advertiser-container{
    margin-top:20px;
    text-align: center;
  position: relative;
  overflow: auto;
}
.advertiser-container img{
  max-height: 100%;
  max-width: 100%;
}
.advertiser-side {
  padding-top: 35px;
}

#home .md-card{
    padding:15px 10px;
    margin: 0;
    height: 250px;

}
#home .md-card-content{
    text-align: center;

}
#home .md-card:hover{
    background-color:#f2f2f2;
}

#home .md-card h3{
    margin-top:30px;
}
#home .md-icon{
    margin-top:20px;
    font-size:75px !important;
    color: #28ADC4;
}
.about p{
    font-size: 14px
}
.az-staff .card-description{
    color:#333;
    font-size:12px;
    margin-bottom: 20px;

}
.az-staff h4{
    margin-top:0;
    margin-bottom:5px
}
.az-staff .md-card-content{
    margin-top: 5px !important
}

.az-staff .card-description{
    margin-bottom: 5px !important
}


@media only screen and (max-width: 992px) {
  .md-card p {
    line-height: 1.2em;
    font-size: 12px;
  }
  .md-card h3 {
    font-size: 18px;
  }
  #home .md-card{
    height: 220px;
  }
}

@media only screen and (max-width: 768px) {
  .md-card p {
    line-height: 1.2em;
    font-size: 10px;
  }
  .md-card h3 {
    margin-top: 15px !important;
    font-size: 14px;
  }
  #home .md-card{
    height: 200px;
  }
  #home .md-icon {
    margin-top: 10px;
    font-size: 45px !important;
  }

}

@media only screen and (max-width: 600px) {
  #home .md-card p {
    display: none;
  }
  #home .md-card-content{
    padding: 5px 0px ;
  }
  #home .md-card{
    height: 120px;
  }
  #home .md-card.mt20{
    height: 120px;
    margin-top: 20px;
  }
  .md-card h3 {
    font-size: 14px;
  }
  .advertiser-container img{
    width: auto;
    min-height: 20px;
    max-height: 100px;
  }
  .adv{
    display: none
  }
}

</style>


